export const feedbackTypeName = 'Feedback';
export const generalAudienceName = 'General';

export const audienceStudentId = 10;
export const audienceTeacherId = 30;
export const audienceGeneralId = 50;
export const typeFeedbackId = 500;
